import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UUID } from '@/types';
import { RootState } from '@/store';

type State = {
  initialPathname: Maybe<string>;
  undoStack: UUID[];
  redoStack: UUID[];
};

const initialState: State = {
  initialPathname: null,
  undoStack: [],
  redoStack: [],
};

export const queryBuilderStepsUndoRedoSlice = createSlice({
  name: 'queryBuilderStepsUndoRedoSlice',
  initialState,
  reducers: {
    setInitialPathname: (
      state,
      action: PayloadAction<NonNullable<State['initialPathname']>>,
    ) => {
      if (!state.initialPathname) {
        state.initialPathname = action.payload;
      }
    },
    reset: (_state) => initialState,
    addToUndoStack: (state, action: PayloadAction<UUID>) => {
      if (!state.undoStack.includes(action.payload)) {
        state.undoStack.unshift(action.payload);
        state.redoStack = [];
      }
    },
    undo: (state) => {
      const id = state.undoStack.shift();

      if (id) state.redoStack.unshift(id);
    },
    redo: (state) => {
      const id = state.redoStack.shift();

      if (id) state.undoStack.unshift(id);
    },
  },
});

export const selectInitialPathname = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].initialPathname;
export const selectIsUndoStackEmpty = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].undoStack.length === 0;

export const selectIsRedoStackEmpty = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].redoStack.length === 0;

export const selectUndoStack = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].undoStack;

export const selectRedoStack = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].redoStack;

export const selectPenultimateUndoId = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].undoStack[1];

export const selectLatestRedoId = (state: RootState) =>
  state[queryBuilderStepsUndoRedoSlice.name].redoStack[0];

export const { setInitialPathname, reset, addToUndoStack, undo, redo } =
  queryBuilderStepsUndoRedoSlice.actions;
